export const name = 'listInteractableUI';
export const description = 'Lists all visible buttons, links, and interactable UI elements on the current page, along with their IDs.';
export const parameters = {};
export const outputTextForUI = 'Interaktív elemek listázása';
export const useOnMobile = false;

export function listInteractableUI() {
  const pageContent = document.querySelector('.page-content');
  const appRoot = document.querySelector('.app') || document.querySelector('#root') || document.body;
  const root = pageContent || appRoot;

  if (!root) {
    throw new Error('Nem található a főoldal tartalomtárolója.');
  }

  function isVisible(el: HTMLElement): boolean {
    if (el.offsetWidth === 0 || el.offsetHeight === 0) return false;
    const style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
    return true;
  }

  function isAiSidebar(el: HTMLElement): boolean {
    return !!(
      el.closest('.mantine-Drawer-root') ||
      el.closest('[class*="Drawer"]') ||
      el.closest('.ai-sidebar') ||
      el.id === 'ai-sidebar'
    );
  }

  const allElements = Array.from(root.querySelectorAll('*')) as HTMLElement[];
  const candidates = allElements.filter(el => {
    if (!isVisible(el) || isAiSidebar(el)) return false;

    const tagName = el.tagName.toUpperCase();
    if (tagName === 'BUTTON' || tagName === 'A') return true;

    const role = el.getAttribute('role');
    if (role && ['button', 'link', 'checkbox', 'radio', 'menuitem', 'tab'].includes(role.toLowerCase())) return true;

    const className = el.className;
    if (typeof className === 'string' && (
      className.includes('Button') ||
      className.includes('ActionIcon') ||
      className.includes('UnstyledButton')
    )) return true;

    const style = window.getComputedStyle(el);
    if (style.cursor === 'pointer') return true;

    return false;
  });

  const interactables = candidates.filter(el => {
    let parent = el.parentElement;
    while (parent) {
      if (candidates.includes(parent)) {
        return false;
      }
      parent = parent.parentElement;
    }
    return true;
  });

  const list = interactables.map((el, index) => {
    const id = String(index);
    el.setAttribute('data-ai-id', id);

    const text = el.innerText || el.textContent || '';
    const label = el.getAttribute('aria-label') || el.getAttribute('title') || el.getAttribute('placeholder') || '';
    const type = el.tagName.toLowerCase();

    return {
      id,
      type,
      text: text.trim().substring(0, 100),
      label: label.trim()
    };
  });

  return {
    message: `${list.length} db interaktív elemet találtam az oldalon.`,
    elements: list
  };
}
